<div mat-dialog-header class="title">
    Add Muckpile
</div>
<div mat-dialog-content class="add-muckpile-dialog" [ngClass]="{'vp-layout': uploadType === 'VantagePoint'}" *ngIf="step==='upload'">
    <div class="flex-row gap-medium wrap">
        <div class="icon-box" [ngClass]="{active: uploadType === 'Manual'}" (click)="showDrawingManager()">
            <mat-icon svgIcon="manual-draw"></mat-icon>
            <span>Manual</span>
        </div>
        <div class="icon-box" [ngClass]="{active: uploadType === 'GeoJSON'}" (click)="uploadType='GeoJSON'">
            <mat-icon svgIcon="geojson"></mat-icon>
            <span>GeoJSON</span>
        </div>
        <div class="icon-box" [ngClass]="{active: uploadType === 'CSV'}" (click)="uploadType='CSV'">
            <mat-icon svgIcon="csv"></mat-icon>
            <span>CSV</span>
        </div>
        <div *ngIf="showVpOption$ | async" class="icon-box" [ngClass]="{active: uploadType === 'VantagePoint'}"
            (click)="uploadType='VantagePoint'">
            <mat-icon svgIcon="muckpile-blue"></mat-icon>
            <span>VP</span>
        </div>
    </div>
    <div class="container upload-content">
        <file-upload *ngIf="uploadType && uploadType !== 'Manual' && uploadType !== 'VantagePoint'"
            [labelText]="fileUploadText" [disabled]="!accepts" [accept]="accepts" [(ngModel)]="file"
            (ngModelChange)="onFileChange($event)"></file-upload>
        <div *ngIf="fileErrorMessage" class="error-message">
            {{ fileErrorMessage }}
        </div>
    </div>
    
    <ng-container *ngIf="uploadType === 'VantagePoint'">
        <div *ngIf="(vpMuckpileManager$ | async) === undefined" class="container centered-content vp-loader">
            <mat-spinner strokeWidth="3" [diameter]="40"></mat-spinner>
        </div>
    
        <ng-container *ngIf="vpMuckpileManager$ | async as vpManager">
            <mat-tab-group [(selectedIndex)]="vpMuckpileTabIndex" class="muckpile-tabs vp-dialog-tabs">
                <mat-tab [label]="'Existing Muckpiles (' + vpManager.existingMuckpiles.length + ')'">
                    <div class="vp-tab-copy">
                        <div class="vp-section-title">Existing Muckpiles</div>
                        <div class="vp-section-subtitle">
                            These muckpiles already exist in Netra and are linked with Vantage Point.
                        </div>
                    </div>
    
                    <div *ngFor="let muckpile of vpManager.existingMuckpiles; trackBy: trackByRegionGuid"
                        class="vp-region-card container">
                        <div class="vp-region-copy">
                            <div class="vp-region-title">{{ muckpile.name }}</div>
                            <div class="vp-region-subtitle">Netra muckpile: {{ muckpile.blastSiteName }}</div>
                            <div class="vp-region-meta" *ngIf="!muckpile.blastSiteIsActive">
                                <span class="vp-tag muted">Inactive in Netra</span>
                            </div>
                        </div>
                        <div class="vp-card-actions">
                            <button mat-stroked-button [disabled]="isVpActionPending('sync:' + muckpile.regionGuid)"
                                (click)="syncVpMuckpile(muckpile.regionGuid)">
                                Sync
                            </button>
                            <button mat-flat-button color="warn"
                                [disabled]="isVpActionPending('remove:' + muckpile.regionGuid)"
                                (click)="removeVpMuckpile(muckpile)">
                                Remove
                            </button>
                        </div>
                    </div>
    
                    <div *ngIf="vpManager.existingMuckpiles.length === 0" class="container centered-content vp-empty-state">
                        <div class="container centered-content">
                            <div>
                                <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                            </div>
                            <div>No Data Found</div>
                        </div>
                    </div>
                </mat-tab>
    
                <mat-tab [label]="'Non Existing Muckpiles (' + vpManager.nonExistingMuckpiles.length + ')'">
                    <div class="vp-tab-copy">
                        <div class="vp-section-title">Non Existing Muckpiles</div>
                        <div class="vp-section-subtitle">
                            These muckpiles are available in Vantage Point only. Add them to Netra to move them into
                            Existing Muckpiles.
                        </div>
                    </div>
    
                    <div *ngFor="let muckpile of vpManager.nonExistingMuckpiles; trackBy: trackByRegionGuid"
                        class="vp-region-card container">
                        <div class="vp-region-copy">
                            <div class="vp-region-title">{{ muckpile.name }}</div>
                            <div class="vp-region-subtitle">{{ muckpile.pointsCount }} points in VP boundary</div>
                        </div>
                        <div class="vp-card-actions">
                            <button mat-flat-button color="primary"
                                [disabled]="isVpActionPending('add:' + muckpile.regionGuid)"
                                (click)="addVpMuckpile(muckpile.regionGuid)">
                                Add
                            </button>
                        </div>
                    </div>
    
                    <div *ngIf="vpManager.nonExistingMuckpiles.length === 0"
                        class="container centered-content vp-empty-state">
                        <div class="container centered-content">
                            <div>
                                <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                            </div>
                            <div>No Data Found</div>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </ng-container>
    </ng-container>
</div>

<div class="full-width container" [ngClass]="showReviewMap ? 'muckpile-map' : 'hide-map'">
    <div #importmap class="map full-width"></div>
    <div class="container">
        <mat-form-field class="full-width" appearance="outline">
            <mat-label>Enter Muckpile Name</mat-label>
            <input matInput [(ngModel)]="blastSite.name" placeholder="Muckpile Name" required>
        </mat-form-field>
    </div>
        <div mat-dialog-actions>
        <button mat-button (click)="goBack('upload')">Back</button>
        <button mat-button (click)="cancel()">Cancel</button>
        <button mat-flat-button color="primary" [disabled]="!file || !blastSite.name" (click)="uploadFile(file)">Upload</button>
    </div>
</div>

<div mat-dialog-actions *ngIf="step==='upload' && uploadType === 'CSV'">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!file" (click)="handleFileNext(file)">Next</button>
</div>

<div class="container" *ngIf="step==='preview' && !showReviewMap">
    <div class="font-bold">
        Please review the uploaded file. Ensure the detected columns labels are correct.
    </div>
    <spreadsheet [headers]="csv.headers" [headerTitles]="headerOptions" [headersSwappable]="headersSwappable"
        [rows]="csv.rows" (headersChange)="onHeadersChanged()"></spreadsheet>
</div>
<div mat-dialog-actions class="mat-mdc-dialog-actions action" *ngIf="((uploadType === 'GeoJSON' || (uploadType === 'CSV' && step==='preview' && !showReviewMap)) && !showReviewMap)">
    <button mat-button *ngIf="uploadType !== 'GeoJSON'" (click)="goBack('reviewMap')">Back</button>
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!file || (!validFile && uploadType === 'GeoJSON') || (!csvHeadersValid && uploadType === 'CSV')" (click)="handleReviewOnMap(file)">Review On Map</button>
</div>